"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEasyLayout = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const getPascalCaseAreaName = (area) => {
    return area
        .split("-")
        .map((a) => a[0].toUpperCase() + a.slice(1))
        .join("");
};
const convertLayoutToCSS = (layout = "") => {
    const lines = layout.split("\n");
    let areaRows = [];
    let rows = [];
    let css = "";
    for (let i = 0; i < lines.length; i++) {
        const line = lines[i].trim();
        if (line.indexOf("\\") === 0) {
            // Column Widths
            css += `\ngrid-template-columns: ${line.split("\\").join("").trim()};`;
        }
        else {
            const parts = line.split(",").map((p) => p && p.trim());
            if (parts[0]) {
                areaRows = [...areaRows, parts[0]];
                if (parts[1]) {
                    rows = [...rows, parts[1]];
                }
            }
        }
    }
    css += `\ngrid-template-areas:\n${areaRows
        .filter((a) => !!(a && a.trim()))
        .map((a) => `  "${a}"`)
        .join("\n")};`;
    if (rows.length) {
        css += `\ngrid-template-rows: ${rows
            .filter((r) => !!(r && r.trim()))
            .join(" ")};`;
    }
    const areasList = Object.keys(areaRows
        .reduce((acc, a) => [
        ...acc,
        ...a
            .split(" ")
            .map((a) => a && a.trim())
            .filter((a) => !!a),
    ], [])
        .reduce((acc, a) => (Object.assign(Object.assign({}, acc), { [a]: true })), {}));
    return {
        areasList,
        css,
    };
};
/**
 * Quickly express advanced, extensible grid layouts with styled-components.
 *
 * @example
 * ```tsx
 * const {
 *   layout: Container,
 *   areas: {
 *     Header,
 *     Side,
 *     Main,
 *     Footer,
 *   },
 * } = getEasyLayout(styled.div)`
 *   header header header, 1fr
 *   side main main, 5fr
 *   footer footer footer, 1fr
 *   \\ 1fr 1fr 1fr
 * `;
 *
 * const App = () => {
 *   return (
 *     <Container>
 *       <Header>Header Content</Header>
 *       <Side>Side Content</Side>
 *       <Main>Main Content</Main>
 *       <Footer>Footer Content</Footer>
 *     </Container>
 *   );
 * };
 * ```
 * */
const getEasyLayout = (extendFrom, areasExtendFrom) => {
    return (layoutTemplate, ...expressions) => {
        const mergedTemplate = layoutTemplate.reduce((acc, l, ind) => {
            const expr = expressions[ind - 1];
            const exprStr = typeof expr === "undefined" ? "" : expr;
            return `${acc}${l}${exprStr}`;
        }, "");
        const { areasList, css } = convertLayoutToCSS(mergedTemplate);
        const baseLayoutComp = extendFrom ? (0, styled_components_1.default)(extendFrom) : styled_components_1.default.div;
        const layout = baseLayoutComp `
    display: grid;
    ${css}
  `;
        const areas = areasList.reduce((acc, area) => {
            const pascalCaseAreaName = getPascalCaseAreaName(area);
            const baseCompFunc = areasExtendFrom
                ? (0, styled_components_1.default)(areasExtendFrom)
                : styled_components_1.default.div;
            const component = baseCompFunc `
      grid-area: ${area};
    `;
            return Object.assign(Object.assign({}, acc), { [pascalCaseAreaName]: component });
        }, {});
        return {
            layout,
            areas,
        };
    };
};
exports.getEasyLayout = getEasyLayout;
